import { requestWithAuth } from "./http";

const API_BASE = "https://api.touchprop.com/api/v1/features";

export function getEconomicCalendar({ signal } = {}) {
  return requestWithAuth(
    `${API_BASE}/economic-calendar/?range=week`,
    { method: "GET", signal },
    { fallbackMessage: "خطا در دریافت تقویم اقتصادی" }
  );
}
